import { useState } from 'react'

interface OptimizedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string
  alt: string
  fallbackSrc?: string
  loading?: 'lazy' | 'eager'
  width?: number
  height?: number
  className?: string
  priority?: boolean
}

const OptimizedImage = ({
  src,
  alt,
  fallbackSrc = 'https://via.placeholder.com/320x192/bfa757/ffffff?text=Noé+Connect',
  loading = 'lazy',
  width = 320,
  height = 192,
  className = '',
  priority = false,
  ...props
}: OptimizedImageProps) => {
  const [hasError, setHasError] = useState(false)

  const loadingAttr = priority ? 'eager' : loading

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    setHasError(true)
    if (props.onError) props.onError(e)
  }



  const imageSrc = hasError ? fallbackSrc : src

  return (
    <img
      src={imageSrc}
      alt={alt}
      loading={loadingAttr}
      width={width}
      height={height}
      decoding="async"
      className={`max-w-full h-auto ${className}`}
      onError={handleError}
      {...props}
    />
  )
}

export default OptimizedImage
